import { useState } from "react"

import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"

import {
  ProjectHistoryModel,
  useProjectHistoryModel
} from "widgets/project-history/model/useProjectHistoryModel"
import { ProjectHistoryFilterState } from "widgets/project-history/project-history-filter/ProjectHistoryFilter"

export interface ProjectHistoryOverlayModel {
  historyModel: ProjectHistoryModel
  filterValues: ProjectHistoryFilterState
  onFilterChange: (state: ProjectHistoryFilterState) => void
  onClose: () => void
}

export function useProjectHistoryOverlayModel({
  payload
}: {
  payload: { projectID: string }
}): ProjectHistoryOverlayModel {
  const { closeOverlay } = useCurrentOverlay()
  const [filterValues, setFilterValues] = useState<ProjectHistoryFilterState>({
    timeFrame: 30,
    searchTerm: ""
  })

  const historyModel = useProjectHistoryModel({
    projectID: payload.projectID,
    filterValues
  })

  return {
    historyModel,
    filterValues,
    onFilterChange: setFilterValues,
    onClose: closeOverlay
  }
}
